import React from 'react';
import { Alert, Button, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { GrowConnectCard } from './GrowConnectCard';

/**
 * Grow reviews a real, live page for the business -- what it sells, its contact details, its
 * policies -- before approving, and we send them the account's storefront short link as that
 * page. This is the gate merchants hit most, so it explains why rather than just refusing.
 */
export const GrowConnectBlocked = () => {
  const { t } = useTranslation();

  return (
    <GrowConnectCard title={t('growConnect.blocked.title')}>
      <Alert severity="info">{t('growConnect.blocked.body')}</Alert>
      <Grid container justifyContent="center">
        <Button variant="contained" component={Link} to="/dashboard/storefronts">
          {t('growConnect.blocked.cta')}
        </Button>
      </Grid>
    </GrowConnectCard>
  );
};
